import React, { useState } from "react";
import { post } from "../../lib/Fetching";
import Button from "../Button";

export default function ContractReviewForm({
  sampleIds,
  onSampleUpdate,
  reloadData,
  loadSelectedSamples
}) {
  const [loading, setLoading] = useState(false);
  const valid = sampleIds.length > 0;

  const performContractReview = () => {
    if (!valid) return;
    setLoading(true);
    post("/contract_review/contract_reviews", {
      sample_ids: sampleIds
    })
      .then(json => {
        if (json.errors) {
          alert(json.errors);
        } else {
          reloadData();
        }
        setLoading(false);
      })
      .catch(errors => {
        alert(errors);
        setLoading(false);
      });
  };

  return (
    <div className="contract-review-form">
      <p>There are {sampleIds.length} selected samples</p>
      <Button
        disabled={!valid || loading}
        onClick={performContractReview}
        title={loading ? "Please wait..." : I18n.t("perform-contract-review")}
        primary
      />
    </div>
  );
}
